<script>
    import { onMount } from "svelte";
    import { location } from "svelte-spa-router";
    import { changeBgColor } from "../scripts/utils";
    import { lang } from "../scripts/stores";
    import infoData from "../scripts/infodata";

    let index = 0;

    $: if($location) index = parseUrl($location);

    function parseUrl(url) {
        const parsedUrl = url.replace("/info/", "");
        const dataIndex = Number(parsedUrl);

        console.log("dataindex", dataIndex);
        if(isNaN(dataIndex)) return 0;
        else return dataIndex;
    }

    onMount(() => {
        changeBgColor("#fff");
        window.scrollTo(0, 0);
    });
</script>

<style>
    .info-container {
        width: 95%;
        max-width: 980px;
        margin: 2rem auto;
    }

    .info-container ul {
        list-style: circle;
        margin-left: 1rem;
    }
    .info-container ul li { margin-bottom: 1rem; }
    p { margin: 2rem 0; }
</style>

<div class="info-container">
    <h2>{ infoData[index].title }</h2>
    
    {#each infoData[index].lists as list}
        <h3> { list.title } </h3>
        <ul>
            {#each list.data as content}
                <li> { content } </li>
            {/each}
        </ul>
    {/each}
    
    <p> { @html infoData[index].paragraph } </p>

    <a href="/#/results-page" class="btn btn-primary btn-outlined">Palaa tuloksiin</a>
</div>